module.exports = __webpack_public_path__ + "img/B2Bservice.82982f4.jpg";